import React from 'react';
import { useTranslation } from 'next-i18next';
import { useSelector } from 'react-redux';

import {
  selectGiftCardsDiscountData,
  selectGiftCardsOrderTotal,
} from '@selectors/giftCards';

import { numberToSup } from '@utils/formatNumber';

import Typography from '@common/components/Typography';
import PriceText from '@common/components/PriceText';
import { isValidDiscount } from '../GiftCardsPurchase.helpers';

import {
  OrderTotalWrapper,
  OrderTotalTitle,
  OrderTotalDeliveryNote,
  OrderTotalBeforeDiscount,
} from './TotalValue.styled';

const TotalValue = () => {
  const { t } = useTranslation();
  const discount = useSelector(selectGiftCardsDiscountData);
  const orderTotal = useSelector(selectGiftCardsOrderTotal);
  const isDiscount = isValidDiscount(discount);

  return (
    <OrderTotalWrapper>
      <OrderTotalTitle>
        {t('giftCards.order.price.Title', 'Total')}
      </OrderTotalTitle>
      {isDiscount && !!orderTotal && (
        <OrderTotalBeforeDiscount>
          {t('giftCards.order.price.total', 'CHF {{totalPrice}}', {
            totalPrice: numberToSup(orderTotal),
          })}
        </OrderTotalBeforeDiscount>
      )}
      <Typography variant="h3" customAs="p">
        <PriceText>
          {isDiscount
            ? t('giftCards.order.price.sale', 'CHF {{salePrice}}', {
                salePrice: numberToSup(
                  orderTotal * (1 - discount.discountPercentage / 100),
                ),
              })
            : t('giftCards.order.price.total', 'CHF {{totalPrice}}', {
                totalPrice: numberToSup(orderTotal),
              })}
        </PriceText>
      </Typography>
      <OrderTotalDeliveryNote>
        {t('giftCards.order.price.deliveryNote', 'Portofreie Lieferung')}
      </OrderTotalDeliveryNote>
    </OrderTotalWrapper>
  );
};

export default TotalValue;
